const config = {
  SSO_CLIENT_ID: "03330-indahdev-l3n",
  // BASE_API_URL: "http://localhost:8020",
  // BASE_API_URL_DEV: "https://localhost:8020",
  BASE_API_URL: "https://indah-api.bps.go.id",
  BASE_API_URL_DEV: "https://indah-api-dev.bps.go.id",
  // BASE_API_URL: "http://localhost:8020",
  GEOSERVER_API_URL: "https://indah-map.bps.go.id",
}

export default config

